import { ec, ecId, type Row } from '../ability/context.js';
import { resolveEngineFrame } from '../actions/ability-use.js';
import { type RollSource } from '../actions/roll-source.js';
import { boundaryAttempt, boundaryVerdict, heldInventoryRows, type GmBoundaryVerdict } from '../statuses/gm-boundary.js';
import { planResourceRecovery, type RecoveryChanges, type RecoveryReaders } from './resource-recovery-plan.js';
import type { ResourceValues } from './resource-adjust.js';
export { RECOVERY_STATUS_IDS, type ConsumedRecoveryBody, type RecoveryReaders } from './resource-recovery-plan.js';

export interface ResourceRecoveryPlan extends RecoveryChanges { verdict: GmBoundaryVerdict }
/** Explicit empty plan for a scalar-only V edit; the saver never guesses whether a missing browser decision was due. */
export const emptyResourceRecovery = (): ResourceRecoveryPlan => ({ verdict: { rows: [], ec: {}, statusesAdded: [], statusesRemoved: [],
  statusStacks: [], charges: [], playerCharactersChanged: [] }, monsterBitRemovals: [], bodies: [] });

/** Uses the shared frame snapshots and extreme-dice checks; neither the page nor a dry run mutates held members. */
export function resolveResourceRecovery(actorId: string, values: ResourceValues, encounter: Row, members: ReadonlyMap<string, Row>,
  read: RecoveryReaders, roll: RollSource) {
  return resolveEngineFrame({}, encounter, members, read, roll, () => {}, ctx => {
    let changes!: RecoveryChanges;
    boundaryAttempt(ctx, 'resource-recovery', (ctx) => { changes = planResourceRecovery(ctx, actorId, values, heldInventoryRows(ctx), read); }, true);
    const verdict = boundaryVerdict(ctx), target = ctx.members.get(actorId.toUpperCase())!;
    // The resource lane saves V once, including any change made by a loss trigger.
    (verdict.ec[ecId(target)] ??= {}).v_current = ec(target).v_current;
    for (const status of verdict.statusesAdded) status.status_id ??= ctx.read.uuid();
    return { verdict, ...changes };
  });
}
